import type { EditorPageFlowConfig } from '@/versions/v1/shared/admin-seed';

export function nextEditorPageFlowConfig(
  config: EditorPageFlowConfig,
): EditorPageFlowConfig {
  return { enabled: !config.enabled };
}

export function editorPageFlowStatusLabel(enabled: boolean): 'ON' | 'OFF' {
  return enabled ? 'ON' : 'OFF';
}
